import { Chip, ChipProps } from "@mui/material";
import React from "react";

import { IProduct } from "../../../generated/types";

interface IProps {
    product: IProduct;
}

export const ProductChip: React.FC<IProps> = ({ product }) => {
    return <Chip {...PRODUCT_DISPLAY_OPTS[product]} size="small" />;
};

const PRODUCT_DISPLAY_OPTS: Record<IProduct, Partial<ChipProps>> = {
    [IProduct.FullLevro]: { label: "Levro", color: "success" },
    [IProduct.Supersheets]: { label: "Omi", color: "info" },
};
